/**
 * The three clocks of the C64 game (spec 02 §1): every 50 Hz frame; an I-tick on every other
 * frame, for players and monsters; an M-tick (a main-loop pass) every FRAMES_PER_PASS frames, for
 * bubbles, items and projectiles - or, with the C64 slowdown option, longer when the screen is busy.
 */

import { FRAMES_PER_PASS } from './tuning';
import type { ClockState } from './types';

export function initialClock(): ClockState {
  return { frame: 0, iTick: false, mTick: false, nextPass: FRAMES_PER_PASS, iTicks: 0, mTicks: 0 };
}

/** Frames the next main-loop pass will take (02 §1.2). */
export function framesPerPass(c64Slowdown: boolean, softwareEntities: number): number {
  if (!c64Slowdown) return FRAMES_PER_PASS;
  return FRAMES_PER_PASS + Math.floor(Math.max(0, softwareEntities - 6) / 6);
}

/** Advance one frame and decide which clocks tick on it. */
export function stepClock(c: ClockState, c64Slowdown: boolean, softwareEntities: number): void {
  c.frame++;
  // The C64 runs sprite movement from the IRQ on odd frames.
  c.iTick = (c.frame & 1) === 1;
  if (c.iTick) c.iTicks++;
  c.mTick = c.frame >= c.nextPass;
  if (c.mTick) {
    c.mTicks++;
    c.nextPass = c.frame + framesPerPass(c64Slowdown, softwareEntities);
  }
}
